/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MPIStrictHttpResponse } from '../../mpi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientModel } from '../../models/patient-model';

export interface ConsumerPost$Params {
      body?: PatientModel
}

export function consumerPost(http: HttpClient, rootUrl: string, params?: ConsumerPost$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, consumerPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MPIStrictHttpResponse<string>;
    })
  );
}

consumerPost.PATH = '/Consumer';
